



























import { Vue, Component, Prop } from 'vue-property-decorator'
import Rating from './StarRating'
import Btn from './Button'
import Comment from './Comment'
import Choice from './Choice'
import FeedbackForm from '@/utils/FeedbackForm'
import { FeedbackFormElement } from '@/types/Feedback.type'
import Datepicker from './Datepicker.vue'

@Component({
    components: {
        Rating,
        Btn,
        Comment,
        Choice,
        Datepicker,
    },
})
export default class FormPart extends Vue {
    @Prop({ required: true }) form!: FeedbackForm
    @Prop({ required: true }) formEl!: FeedbackFormElement
    @Prop({ required: true, default: 0 }) rating!: number
    @Prop({ required: true, default: 0 }) i!: number

    onClick(value: boolean) {
        this.onAnswer(value)
        this.$emit('submit')
    }

    onAnswer(value: unknown) {
        const response = {
            id: this.formEl.id,
            answer: value,
        }

        this.$emit('answer', response)
    }
}
